module.exports = __webpack_public_path__ + "img/hotel3.1e195d82.png";